import { defineStore } from "pinia";
import { WorkExperienceCvInterface } from "@/modules/cv/types";
import {
  apiGetWorkExperiences,
  apiUpdateWorkExperience,
} from "@/modules/work_experiences/_utils/api";
import { PaginationInterface } from "@/common/types";

const headers = { "Cache-Control": "no-cache" };

export interface StateInterface {
  workExperiences: Map<number, any>;
  workExperiencesPagination: PaginationInterface | undefined;
}

export const useWorkExperiencesStore = defineStore("work-experiences", {
  state: (): StateInterface => {
    return {
      workExperiences: new Map(),
      workExperiencesPagination: undefined,
    };
  },
  actions: {
    getWorkExperiencesByPage(params: any) {
      return new Promise((resolve, reject) => {
        apiGetWorkExperiences(params, headers)
          .then((res: any) => {
            this.setWorkExperiences({ page: params.page, payload: res.data.data });
            this.setWorkExperiencesPagination(res.data.meta);
            resolve(res.data.data);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    },

    updateWorkExperience({ workExperienceId, updatedWorkExperience }: any) {
      return new Promise<void>((resolve, reject) => {
        apiUpdateWorkExperience(workExperienceId, updatedWorkExperience)
          .then(() => {
            resolve();
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    },

    clearWorkExperiences() {
      return new Promise<void>((resolve) => {
        this.workExperiences = new Map();
        resolve();
      });
    },

    setWorkExperiences({
      page,
      payload,
    }: {
      page: number;
      payload: Array<WorkExperienceCvInterface>;
    }): void {
      let map = new Map();
      this.workExperiences.forEach((v: number, k: any) => map.set(k, v));
      map.set(page, payload);
      this.workExperiences = map;
    },

    setWorkExperiencesPagination(meta: PaginationInterface) {
      this.workExperiencesPagination = meta;
    },
  },
});
